import * as React from "react";
import {Link} from "react-router-dom";
import {ListItem} from "material-ui/List";
import ContentSend from "material-ui/svg-icons/content/send";
import DashboardIcon from "material-ui/svg-icons/action/dashboard";

export class MenuItem extends React.Component<MenuItemProps> {

    static defaultProps = {
        showTitle: true,
        icon: <DashboardIcon/>
    };

    render() {
        const {url, title, showTitle, subItems, icon, className} = this.props;

        if (!subItems || !subItems.length) {
            return (
                <Link to={url}>
                    <ListItem
                        className={className}
                        leftIcon={icon}
                        onClick={this.props.onClick}
                        primaryText={title}/>
                </Link>
            );
        }

        return (
            <div>
                <ListItem
                    className={className}
                    primaryText={showTitle ? title : ""}
                    style={{height: 50, fontSize: 15}}
                    primaryTogglesNestedList
                    nestedItems={
                        subItems.map(subItem => {
                            return (
                                <Link key={subItem.key} to={subItem.url}>
                                    <ListItem
                                        leftIcon={<ContentSend/>}
                                        className={className}
                                        onClick={this.props.onClick}
                                        primaryText={subItem.name}/>
                                </Link>
                            );
                        })
                    }
                />
            </div>
        );
    }
}

interface MenuItemProps {
    title: string,
    className?: string,
    icon?: any,
    url: string,
    showTitle?: boolean,
    subItems?: Array<SubItem>,
    onClick?: () => void
}

export interface SubItem {
    name: string,
    url: string,
    key: string
}


// WEBPACK FOOTER //
// ./src/co/sura/inicio/componentes/MenuItem.tsx